// src/components/KakaoAdFit.js
import React, { useEffect, useRef } from 'react';

function KakaoAdFit() {
  // 스크립트를 넣을 요소를 지정하기 위한 ref
  const scriptElement = useRef(null);

  useEffect(() => {
    const script = document.createElement("script");
    script.setAttribute("src", "https://t1.daumcdn.net/kas/static/ba.min.js");
    script.setAttribute("charset", "utf-8");
    script.setAttribute("async", "true");

    // scriptElement(div) 안에 스크립트 삽입
    // 이렇게 하면 컴포넌트가 마운트 될 때마다 스크립트가 로드되어 광고를 실행합니다.
    scriptElement.current?.appendChild(script);

    return () => {
      // 컴포넌트 언마운트 시 스크립트 제거 (선택사항이나 깔끔한 처리를 위해 권장)
      // AdFit 스크립트는 전역 객체를 사용하므로 완벽한 정리는 어렵지만 DOM은 정리됩니다.
      if (scriptElement.current) {
        const globalScript = scriptElement.current.querySelector("script");
        if (globalScript) scriptElement.current.removeChild(globalScript);
      }
    };
  }, []);

  return (
    <div ref={scriptElement}>
      <ins
        className="kakao_ad_area"
        style={{ display: "none" }}
        data-ad-unit="DAN-poarBLrbBwAXHged"  // 님의 광고단위 ID
        data-ad-width="300"
        data-ad-height="250"
      ></ins>
    </div>
  );
}

export default KakaoAdFit;